import AddressApi from "@/services/api/addressApi.js";

const AddressApiService = new AddressApi();

export const checkoutHelper = {
  data: function () {
    return {
      address: null,
    };
  },
  methods: {
    async saveAddresses() {
      try {
        const [shippingAddress, billingAddress] = await Promise.all([
          this.address.new_shipping_address &&
            !this.address.selected_shipping_address.id &&
            AddressApiService.create({
              ...this.address.model.shipping_address,
              shipping: this.address.model.shipping_address.save_as_retailer_address,
            }),
          this.address.new_billing_address &&
            !this.address.selected_billing_address.id &&
            AddressApiService.create({
              ...this.address.model.billing_address,
              billing: this.address.model.billing_address.save_as_retailer_address,
            }),
        ]);

        if (shippingAddress) {
          const id = shippingAddress.data.id;

          this.$store.commit("setCheckoutAddressInfo", {
            ...this.address,
            selected_shipping_address: this.$utils.mapAddressToDropdownItem({
              ...this.address.model.shipping_address,
              id,
            }),
          });
        }

        if (billingAddress) {
          const id = billingAddress.data.id;

          this.$store.commit("setCheckoutAddressInfo", {
            ...this.address,
            selected_shipping_address: shippingAddress
              ? this.$store.getters.checkoutState.shipping.selected_shipping_address
              : this.address.selected_shipping_address,
            selected_billing_address: this.$utils.mapAddressToDropdownItem({
              ...this.address.model.billing_address,
              id,
            }),
          });
        }

        this.address = this.$store.getters.checkoutState.shipping;
      } catch (error) {
        if (error.response) {
          this.$swal("Attention", error.response.data.error_message);
        } else {
          this.$logger.notify(new Error(error));
        }
      }
    },
    getAddressConfig() {
      const request = {};
      if (this.address.different_billing) {
        request.use_shipping_as_billing = false;
      } else {
        request.use_shipping_as_billing = true;
      }
      if (this.address.selected_shipping_address && this.address.selected_shipping_address.id) {
        request.saved_shipping_address_id = this.address.selected_shipping_address.id;
      } else {
        request.shipping_address = this.address.model.shipping_address;
      }
      if (this.address.different_billing) {
        if (this.address.selected_billing_address && this.address.selected_billing_address.id) {
          request.saved_billing_address_id = this.address.selected_billing_address.id;
        } else {
          request.billing_address = this.address.model.billing_address;
        }
      }
      return request;
    },
  },
};
